
export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-md mx-auto px-4 py-3 flex items-center gap-2">
          <a href="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-rose-500">
              <i className="ri-heart-pulse-fill text-white text-lg"></i>
            </div>
            <span className="font-bold text-lg text-gray-800" style={{ fontFamily: 'Pacifico, cursive' }}>
              LoveNavi
            </span>
          </a>
        </div>
      </header>

      <main className="max-w-md mx-auto px-4 py-8">
        <h1 className="text-xl font-bold text-gray-800 mb-6">利用規約</h1>
        <p className="text-xs text-gray-400 mb-6">最終更新日：2025年1月1日</p>

        <div className="space-y-6 text-sm text-gray-600 leading-relaxed">
          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">第1条（適用）</h2>
            <p>本規約は、当サイト「LoveNavi」（以下「当サイト」）が提供するすべてのサービスの利用に関する条件を定めるものです。ユーザーは本規約に同意の上、サービスをご利用ください。</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">第2条（定義）</h2>
            <p>本規約において「ユーザー」とは、当サイトを閲覧・利用するすべての方を指します。「サービス」とは、当サイトが提供するマッチングアプリの紹介・比較・レビュー等の情報提供サービスを指します。</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">第3条（禁止事項）</h2>
            <p>ユーザーは、以下の行為を行ってはなりません。</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>当サイトのサーバーまたはネットワークの機能を破壊・妨害する行為</li>
              <li>当サイトの運営を妨害するおそれのある行為</li>
              <li>他のユーザーに関する個人情報等を収集・蓄積する行為</li>
              <li>不正アクセスをし、またはこれを試みる行為</li>
              <li>他のユーザーに成りすます行為</li>
              <li>当サイトのサービスに関連して反社会的勢力に利益を供与する行為</li>
              <li>その他、当サイトが不適切と判断する行為</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">第4条（サービスの提供の停止等）</h2>
            <p>当サイトは、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなくサービスの全部または一部の提供を停止・中断することができるものとします。</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>サービスにかかるシステムの保守点検・更新を行う場合</li>
              <li>地震、落雷、火災、停電等の不可抗力により提供が困難となった場合</li>
              <li>その他、当サイトが提供の停止・中断を必要と判断した場合</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">第5条（著作権）</h2>
            <p>当サイトに掲載されているコンテンツ（文章、画像、動画、デザイン等）の著作権は、当サイトまたは正当な権利を有する第三者に帰属します。無断での複製、転載、改変等は禁止いたします。</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">第6条（免責事項）</h2>
            <p>当サイトは、紹介するマッチングアプリに関する情報の正確性・完全性を保証するものではありません。当サイトを通じて紹介されたアプリの利用により生じた損害について、当サイトは一切の責任を負いません。</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">第7条（リンク先について）</h2>
            <p>当サイトからリンクされた外部サイトについて、当サイトはその内容について一切の責任を負いません。リンク先のサービスの利用は、ユーザー自身の責任において行ってください。</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">第8条（規約の変更）</h2>
            <p>当サイトは、必要と判断した場合には、ユーザーに通知することなく本規約を変更することができるものとします。変更後の利用規約は、当サイトに掲載した時点から効力を生じるものとします。</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">第9条（準拠法・裁判管轄）</h2>
            <p>本規約の解釈にあたっては、日本法を準拠法とします。サービスに関して紛争が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
          </section>
        </div>
      </main>

      <footer className="bg-rose-50 py-6 px-4 mt-8">
        <div className="max-w-md mx-auto">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-gray-400 mb-3">
            <a href="/privacy" className="hover:text-rose-500 transition-colors cursor-pointer">
              プライバシーポリシー
            </a>
            <a href="/terms" className="hover:text-rose-500 transition-colors cursor-pointer">
              利用規約
            </a>
            <a href="/company" className="hover:text-rose-500 transition-colors cursor-pointer">
              運営会社
            </a>
          </div>
          <div className="text-center text-[10px] text-gray-400">
            <p>&copy; 2025 LoveNavi All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
